/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpLeftIcon24Regular = forwardRef('ArrowDUturnUpLeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M9.152.762a.875.875 0 1 1 1.197 1.276l-4.36 4.087H13a7.875 7.875 0 0 1 0 15.75H7a.875.875 0 1 1 0-1.75h6a6.125 6.125 0 0 0 0-12.25H5.936l4.413 4.137a.875.875 0 1 1-1.197 1.276l-4.833-4.53c-1-.939-1-2.527 0-3.466L9.152.762Z" })));
});
